"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$appdxItemHeadLine = exports.detectAppdxItemTitle = exports.appdxItemTitlePtns = void 0;
const factory_1 = __importDefault(require("../factory"));
const _sentenceChildren_1 = require("./$sentenceChildren");
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const util_1 = require("../util");
const controls_1 = require("../../../node/el/controls");
const _tagControl_1 = require("./$tagControl");
exports.appdxItemTitlePtns = [
    ["AppdxFig", /^[別付附]?図/],
    // eslint-disable-next-line no-irregular-whitespace
    ["AppdxStyle", /^(?![付附]則)[^(（ 　\t\r\n]*様式/],
    // eslint-disable-next-line no-irregular-whitespace
    ["AppdxFormat", /^(?![付附]則)[^(（ 　\t\r\n]*書式/],
    ["AppdxTable", /^[別付附]表/],
    ["AppdxNote", /^別[記紙]/],
    ["Appdx", /^[付附]録/],
];
const detectAppdxItemTitle = (text) => {
    for (const [name, ptn] of exports.appdxItemTitlePtns) {
        if (ptn.test(text)) {
            return name;
        }
    }
    return null;
};
exports.detectAppdxItemTitle = detectAppdxItemTitle;
/**
 * The parser rule for {@link AppdxItemHeadLine} that represents a head line of an appended item such as an appended table. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$appdxItemHeadLine.spec.ts) for examples.
 */
exports.$appdxItemHeadLine = factory_1.default
    .withName("appdxItemHeadLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .choice(c => c
    .or(() => _tagControl_1.$appdxControl)
    .or(() => _tagControl_1.$appdxTableControl)
    .or(() => _tagControl_1.$appdxStyleControl)
    .or(() => _tagControl_1.$appdxFormatControl)
    .or(() => _tagControl_1.$appdxFigControl)
    .or(() => _tagControl_1.$appdxNoteControl)
    .orSequence(s => s
    .and(() => _tagControl_1.$autoTagControl, "control")
    .and(r => r
    .choice(c => {
    let choice = c;
    for (const [name, ptn] of exports.appdxItemTitlePtns) {
        choice = choice
            .orSequence(s => s
            .and(r => r.nextIs(r => r.regExp(ptn)))
            .action(() => name));
    }
    return choice;
}), "tag")
    .action(({ tag, control }) => {
    return { tag, control };
}))), "tagControl")
    .and(r => r
    .zeroOrOne(() => _sentenceChildren_1.$sentenceChildrenWithoutToplevelInlineToken), "tail")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, tagControl: { tag, control }, tail, lineEndText }) => {
    const inline = (0, util_1.mergeAdjacentTexts)(tail?.value ?? []);
    const lastItem = inline.length > 0 ? inline[inline.length - 1] : null;
    const [title, relatedArticleNum] = (lastItem instanceof controls_1.__Parentheses
        && lastItem.attr.type === "round") ? [inline.slice(0, -1), inline.slice(-1)] : [inline, []];
    const errors = [
        ...indentsStruct.errors,
        ...(tail?.errors ?? []),
    ];
    return {
        value: new line_1.AppdxItemHeadLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            mainTag: tag,
            controls: control ? [control] : [],
            title,
            relatedArticleNum,
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$appdxItemHeadLine;
//# sourceMappingURL=$appdxItemHeadLine.js.map